import React, { useState } from "react";
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import Subscribe from "./Screens/Subscribe";
import About from "./Screens/About";
import Contact from "./Screens/Contact";
import Services from "./Screens/Services";
import FAQs from "./Screens/FAQs";
import UnderConstruction from "./Screens/UnderConstruction";
import "./App.css";

const App = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <Router>
      {/* ===== HEADER ===== */}
      <header className="header">
        <div className="logo">
          <Link to="/">🌙 Moonwater Healing Arts</Link>
        </div>

        {/* Desktop navigation */}
        {/* <nav className="nav-links">
          <Link to="/subscribe">Subscribe</Link>
          <Link to="/services">Services</Link>
          <Link to="/about">About</Link>
          <Link to="/faqs">FAQs</Link>
          <Link to="/contact">Contact</Link>
        </nav> */}

        {/* Mobile hamburger */}
        {/* <button className="menu-button" onClick={toggleMenu}>
          &#9776;
        </button> */}

        {menuOpen && (
          <div className="dropdown-menu">
            {/* <Link to="/subscribe" onClick={() => setMenuOpen(false)}>Subscribe</Link> */}
            {/* <Link to="/services" onClick={() => setMenuOpen(false)}>Services</Link> */}
            {/* <Link to="/about" onClick={() => setMenuOpen(false)}>About</Link> */}
            {/* <Link to="/faqs" onClick={() => setMenuOpen(false)}>FAQs</Link> */}
            {/* <Link to="/contact" onClick={() => setMenuOpen(false)}>Contact</Link> */}
          </div>
        )}
      </header>

      {/* ===== ROUTES ===== */}
      <Routes>
        {/* <Route path="/subscribe" element={<Subscribe />} /> */}
        {/* <Route path="/services" element={<Services />} /> */}
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/faqs" element={<FAQs />} /> */}
        {/* <Route path="/contact" element={<Contact />} /> */}
        {/* <Route path="/" element={<Subscribe />} /> */}

        {/* UNDER  Construction */}
        <Route path="/" element={<UnderConstruction />} />
      </Routes>
    </Router>
  );
};

export default App;
